<template>
    <div class="nevs-content">
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadRegistrations">
                <tr class="nevs-table-filters">
                    <td>
                        <NevsTextField v-model="tableData.filters.first_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.last_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.email"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.phone"></NevsTextField>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                <tr v-for="(registration, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell" @click="editRegistration(registration)">{{ registration.first_name }}</td>
                    <td class="nevs-table-linked-cell" @click="editRegistration(registration)">{{ registration.last_name }}</td>
                    <td class="nevs-table-linked-cell" @click="editRegistration(registration)">{{ registration.email }}</td>
                    <td class="nevs-table-linked-cell" @click="editRegistration(registration)">{{ registration.phone }}</td>
                    <td class="nevs-table-linked-cell" @click="editRegistration(registration)">{{ registration.created_at_display }}</td>
                    <td class="nevs-table-actions">
                        <span :title="$LANG.Get('tooltips.edit')" class="nevs-table-button" @click="editRegistration(registration)"><i
                            class="fa-solid fa-pen"></i></span>
                        <span :title="$LANG.Get('tooltips.delete')" class="nevs-table-button" @click="deleteRegistration(registration)"><i
                            class="fa-solid fa-trash"></i></span>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";

export default {
    name: "ModuleRegistrations",
    components: {NevsTextField, NevsTable, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'first_name',
                        label: this.$LANG.Get('fields.firstName')
                    },
                    {
                        name: 'last_name',
                        label: this.$LANG.Get('fields.lastName')
                    },
                    {
                        name: 'email',
                        label: this.$LANG.Get('fields.email')
                    },
                    {
                        name: 'phone',
                        label: this.$LANG.Get('fields.phone')
                    },
                    {
                        name: 'created_at',
                        label: this.$LANG.Get('labels.registeredAt')
                    },
                    {
                        name: 'actions',
                        width: '80px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: ''
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'created_at',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            }
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.tableData.filterTimer !== null) {
                    clearTimeout(this.tableData.filterTimer);
                }
                let vm = this;
                this.tableData.filterTimer = setTimeout(function () {
                    vm.reloadRegistrations(vm.tableData.lastRequest);
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        editRegistration(registration) {
            this.$router.push('/registrations/' + registration.id);
        },
        deleteRegistration(registration) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        this.$API.APICall('delete', 'registrations/' + registration.id, {}, (data, success) => {
                            if (success) {
                                vm.reloadRegistrations(vm.tableData.lastRequest);
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        reloadRegistrations(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'registrations', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.tableData.height = window.innerHeight - 205 + 'px';
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'clients');
        this.$store.commit('selectSubMenu', 'registrations');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.clients'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.registrations'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
    unmounted() {
        window.removeEventListener('resize', this.resolveWindowResize);
    }
}
</script>
